// Textfield Component
const SELECTORS = {
    textfield: '.js-textfield'
}

const CLASSES = {
    isFocused: 'is-focused',
    isDirty: 'is-dirty'
}

const ANIMATIONS = {
    autoFillStartAnimation: 'onAutoFillStart',
    autoFillCancelAnimation: 'onAutoFillCancel'
}

class TextField {
    constructor(el) {
        this.textfield = el
        this.input = this.textfield.querySelector('input, textarea')
        this.autoFillListener = null

        this.bindEvents()
        this.checkDirty()
        this.checkAutoFocus()
    }

    bindEvents() {
        this.input.addEventListener('focus', this.onFocus)
        this.input.addEventListener('blur', this.onBlur)
        this.input.addEventListener('input', this.checkDirty)
        this.input.addEventListener('animationstart', e => {
            if (
                e.animationName === ANIMATIONS.autoFillStartAnimation ||
                e.animationName === ANIMATIONS.autoFillCancelAnimation
            ) {
                return this.checkDirty()
            }
        })

        window.addEventListener('load', this.setAutoFillListener)
    }

    onFocus = () => {
        this.textfield.classList.add(CLASSES.isFocused)
        if (this.autoFillListener) {
            clearTimeout(this.autoFillListener)
            this.autoFillListener = null
        }
    }

    onBlur = () => {
        this.textfield.classList.remove(CLASSES.isFocused)
        this.checkDirty()
    }

    checkDirty = () => {
        const isDirty = this.input.value && this.input.value.length > 0
        if (isDirty) {
            this.textfield.classList.add(CLASSES.isDirty)
        } else {
            this.textfield.classList.remove(CLASSES.isDirty)
        }
    }

    checkAutoFocus = () => {
        if (this.input.hasAttribute('autofocus')) {
            this.textfield.classList.add(CLASSES.isFocused)
        }
    }

    setAutoFillListener = () => {
        const backOff = (fn, repeat, delay) => {
            if (repeat > 0) {
                this.autoFillListener = setTimeout(function() {
                    fn()
                    backOff(fn, --repeat, delay * 2)
                }, delay)
            } else {
                clearTimeout(this.autoFillListener)
            }
        }
        backOff(() => this.checkDirty(), 3, 1000)
    }
}

// Register All Textfields
const allTextFields = document.querySelectorAll(SELECTORS.textfield)
Array.from(allTextFields, el => new TextField(el))
